import { createSlice, createEntityAdapter } from '@reduxjs/toolkit';

const positionAdapter = createEntityAdapter({
    selectId: (payment) => payment.guid,
});

const initialState = positionAdapter.getInitialState();

const positionSlice = createSlice({
    name: 'position',
    initialState,
    reducers: {
        // addStages: positionAdapter.setMany,
        addStages: positionAdapter.addMany,
        updateOne: positionAdapter.updateOne,
        updateMany: positionAdapter.updateMany,
    },
});

export const positionSelector = positionAdapter.getSelectors((state) => state.positionReducer);
export const { actions: positionActions } = positionSlice;
export const { reducer: positionReducer } = positionSlice;
